import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import {HashRouter as Router} from "react-router-dom";
import {CustomCSS} from "./components/Style/Custom.CSS";


//  Maintain root instances (important for Liferay SPA)
const rootMap = new Map();

function renderComponent(element) {
    if (!element) return;

    // Prevent duplicate mounting
    if (!rootMap.has(element)) {
        const root = createRoot(element);

        root.render(
            <React.StrictMode>
                <Router>
                    <App />
                    <CustomCSS />
                </Router>
            </React.StrictMode>
        );

        rootMap.set(element, root);
    }
}

// Custom Element
class WebComponent extends HTMLElement {
    connectedCallback() {
        renderComponent(this);
    }

    disconnectedCallback() {
        //  DO NOT unmount (Liferay SPA reuses DOM)
    }
}

const elementId = "pms-forgot-password-element";

// Register custom element
if (!customElements.get(elementId)) {
    customElements.define(elementId, WebComponent);
}

// Initial load
document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector("pms-forgot-password-element");
    renderComponent(el);
});

// Liferay SPA navigation support (CRITICAL)
window?.Liferay?.on("endNavigate", () => {
    const el = document.querySelector("pms-forgot-password-element");
    renderComponent(el);
});
